import PropTypes from 'prop-types';
import React, {Component, Fragment, Suspense} from 'react';
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';

import LoginPage from './containers/auth/LoginPage';
//import RememberPassword from './containers/auth/RememberPassword';

import App from './containers/App';

import ClientsPage from './containers/clients/ClientsPage';
import ClientPage from './containers/clients/ClientPage';
import ErrorsPage from './containers/clients/ErrorsPage';
import CreateClientPage from './containers/clients/CreateClientPage';

import ReportsPage from './containers/reports/ReportsPage';
import ReportPage from './containers/reports/ReportPage';

import NotificationsPage from './containers/notifications/NotificationsPage';
import NotificationPage from './containers/notifications/NotificationPage';

import DealersPage from './containers/dealers/DealersPage';
import DealerPage from './containers/dealers/DealerPage';
import UsersPage from './containers/users/UsersPage';
import UserPage from './containers/users/UserPage';
import AuthContainer from './containers/auth/AuthContainer';

import FotaCarsPage from './containers/fota/FotaCarsPage';
import CreateFotaCarPage from './containers/fota/CreateFotaCarPage';
import FotaCarPage from './containers/fota/FotaCarPage';

import FirmwaresPage from './containers/fota/FirmwaresPage';
import FirmwarePage from './containers/fota/FirmwarePage';
import CreateFirmwarePage from './containers/fota/CreateFirmwarePage';

import CampaignsPage from './containers/fota/CampaignsPage';
import CreateCampaignPage from './containers/fota/CreateCampaignPage';

import GlobalSearchPage from './containers/GlobalSearchPage';

import {connect} from 'react-redux';
import StartupActions from './redux/StartupRedux';
import MessagesActions from './redux/MessagesRedux';
import Flag, {FlagGroup} from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import {colors} from '@atlaskit/theme';
import Info from '@atlaskit/icon/glyph/info';
import Tick from '@atlaskit/icon/glyph/check-circle';
import DiagnosticPage from './containers/diagnostic/DiagnosticPage';
import CampaignPage from './containers/fota/CampaignPage';
import BillingPage from './containers/billing/BillingPage';


class MainRouter extends Component {
  constructor() {
    super();
    this.state = {
      firstStart: true,
      navOpenState: {
        isOpen: true,
        width: 304,
      }
    }
  }

  componentDidMount() {
    this.props.startup();
  }

  runTimer() {
    setTimeout(() => {
      this.props.dismissError();
    }, 5000);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.authFetching
      && prevProps.authFetching !== this.props.authFetching) {
        this.setState({firstStart: false});
    }
    if (this.props.msgs && this.props.msgs.length > 0) {
      this.runTimer();
    }
  }

  getChildContext () {
    return {
      navOpenState: this.state.navOpenState,
    };
  }

  onNavResize = (navOpenState) => {
    this.setState({
      navOpenState,
    });
  }

  render() {
    const {
      authToken,
      authFetching
    } = this.props;

    return (
      <Fragment>
        <BrowserRouter>
          {authToken && !authFetching ? (
          <App
            onNavResize={this.onNavResize}
            {...this.props}
          >
            <Suspense fallback=''>
            <Switch>
              <Redirect exact from='/' to='/clients' />
              <Route path='/clients/:id/:carId/errors' component={ErrorsPage} />
              <Route path='/clients/new' component={CreateClientPage} />
              <Route path='/clients/:id' component={ClientPage} />
              <Route exact path='/clients' component={ClientsPage} />
              <Route exact path='/billing' component={BillingPage} />
              <Redirect path='/billing/:id' to='/clients/:id' />
              <Route exact path='/reports' component={ReportsPage} />
              <Route path='/reports/:id' component={ReportPage} />
              <Route exact path='/notifications' component={NotificationsPage} />
              <Route path='/notifications/:id' component={NotificationPage} />
              <Route exact path='/diagnostic' component={DiagnosticPage} />
              <Route exact path='/dealers' component={DealersPage} />
              <Route path='/dealers/:id' component={DealerPage} />
              <Route path='/users/:id' component={UserPage} />
              <Route exact path='/users' component={UsersPage} />
              <Route exact path='/search' component={GlobalSearchPage} />
              <Route exact path='/fotaCars' component={FotaCarsPage} />
              <Route exact path='/fotaCars/new' component={CreateFotaCarPage} />
              <Route exact path='/fotaCars/:id' component={FotaCarPage} />
              <Route exact path='/firmwares' component={FirmwaresPage} />
              <Route exact path='/firmwares/new' component={CreateFirmwarePage} />
              <Route exact path='/firmwares/:id' component={FirmwarePage} />  
              <Route exact path='/campaigns' component={CampaignsPage} />
              <Route exact path='/campaigns/new' component={CreateCampaignPage}/>
              <Route exact path='/campaigns/:id' component={CampaignPage}/>
              <Redirect from='*' to='/' />
            </Switch>
            </Suspense>
          </App>
          ) : this.state.firstStart ? null : (
          <AuthContainer>
            <Suspense fallback=''>
            <Switch>
              <Route path='/login' component={LoginPage} />
              <Redirect from='*' to='/login' />
            </Switch>
            </Suspense>
          </AuthContainer>
          )}
        </BrowserRouter>
        <FlagGroup /* < onDismissed={this.props.dismissError}*/> 
          {this.props.msgs.map((msg, index) => (
            <Flag
              icon={
                {
                  info: <Info label="Info icon" secondaryColor={colors.N500} />,
                  success: <Tick label="Success" secondaryColor={colors.G400} />,
                }[msg.type] || <ErrorIcon label="Error" secondaryColor={colors.R400} />
              }
              appearance={msg.type ? msg.type : 'error'}
              id={`autoDismissFlag_${index}`}
              key={`autoDismissFlag_${index}`}
              title={msg.title}
              description={msg.text}
            />
          ))}
        </FlagGroup>
      </Fragment>
    );
  }
}

MainRouter.childContextTypes = {
  navOpenState: PropTypes.object,
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions,
    authToken: state.auth.token,
    authFetching: state.auth.fetching,
    msgs: state.messages.data,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    startup: () => dispatch(StartupActions.startup()),
    dismissError: () => dispatch(MessagesActions.messagesDismiss()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MainRouter);